import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MENU } from '../constants/index';
import Home from '../pages/Home';
import Service from '../pages/Service';
import Example from '../pages/Example';
import Consult from '../pages/Consult';

const useStyles = makeStyles(() => ({
  main: {
    background: '#fff'
  }
}));

const MainContent: React.FC<{ menuKey: string, setMenu: React.Dispatch<React.SetStateAction<string>> }> = ({ menuKey, setMenu }) => {
  const classes = useStyles();
  const content = useMemo(() => {
    switch (menuKey) {
      case MENU.home:
        return <Home setMenu={setMenu} />;
      case MENU.service:
        return <Service />;
      case MENU.example:
        return <Example />;
      case MENU.consult:
        return <Consult />;
      default:
        return <Home setMenu={setMenu} />;
    }
  }, [menuKey, setMenu]);

  return (
    <div className={classes.main}>{content}</div>
  );
};

export default MainContent;